import { Card, CardContent, Typography, Box } from '@mui/material'
import { FREQUENCY_CARD_STYLES } from '../../constants/ClientDashboardConst'

export default function FrequencyCard({
  title,
  value,
  icon,
  valueColor = FREQUENCY_CARD_STYLES.valueColor
}) {
  return (
    <Card
      elevation={4}
      sx={{
        borderRadius: 2,
        height: 80,
        width: 350,
        border: '3px solid #E4E4E4',
        boxShadow: 0
      }}
    >
      <CardContent>
        <Box display="flex" alignItems="center" gap={2}>
          <Box
            sx={{
              width: 44,
              height: 44,
              borderRadius: '50%',
              backgroundColor: FREQUENCY_CARD_STYLES.iconBg,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: FREQUENCY_CARD_STYLES.iconColor
            }}
          >
            {icon}
          </Box>

          <Box>
            <Typography
              variant="caption"
              color="text.secondary"
              fontWeight={600}
            >
              {title}
            </Typography>

            <Typography
              variant="h5"
              fontWeight={700}
              sx={{
                mt: -0.5,
                color: valueColor
              }}
            >
              {value}
            </Typography>
          </Box>
        </Box>
      </CardContent>
    </Card>
  )
}
